export default __webpack_public_path__ + "static/media/3.b0583cd9.jpg";